module.exports = __webpack_public_path__ + "img/al_taglio_960px.9e31952c.jpg";